import { html } from "lit";
import { customElement } from "lit/decorators.js";
import { BaseElement } from "../BaseElement";
import { styles } from "./MediaUploadBrowser.style";
import { until } from "lit/directives/until.js";

import "./MediaUpload";

@customElement("ds-media-upload-browser")
export class MediaUploadBrowser extends BaseElement {
    static override styles = [styles];

    public override async connectedCallback(): Promise<void> {
        super.connectedCallback();
        this._subscribeToKernelEvent(
            ["media-upload-job-complete", "media-upload-job-deleted"],
            () => this.requestUpdate()
        );
    }

    private async _renderOutstanding() {
        const outstanding = await this._kernel.mediaLibrary.outstandingJobs();
        return html`<div class="flex-column">
            ${outstanding.map((x) => html`<ds-media-upload .job=${x}></ds-media-upload>`)}
        </div>`;
    }

    override render() {
        return html`${until(this._renderOutstanding(), html`<sl-progress-bar></sl-progress-bar>`)}`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        "ds-media-upload-browser": MediaUploadBrowser;
    }
}
